import {
    Button,
    Dropdown,
    fetchRoute,
    getCalendarFormat,
    Link,
    TDataTableColumnsData,
    TDataTableRowData,
    Typography
} from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { t } from "i18next"
import { NameTableCol } from "../../components/tables/nameTableCol"
import { ERoutes } from "../../utils/url"
import { TGetListingRowsAutomation } from "./types"

export function getListingColsData(): () => TDataTableColumnsData[] {
    return () => [
        {
            id: "name",
            label: t("general-name"),
            sortable: true
        },
        {
            id: "status",
            label: t("general-status"),
            sortable: true
        },
        {
            id: "list",
            label: t("general-list"),
            sortable: true
        },
        {
            id: "created_on",
            label: t("general-created_on"),
            sortable: true
        },
        {
            id: "updated_on",
            label: t("general-updated_on"),
            sortable: true
        },
        {
            id: "actions",
            label: ""
        }
    ]
}

export function getListingRows({
    index,
    automation,
    partialList,
    handleViewAutomation,
    getActionsDropdownOptions,
    renderStatusChip
}: TGetListingRowsAutomation): TDataTableRowData {
    const actions: any = (
        <Stack direction="row" gap={3}>
            <Button
                variant="outlined"
                size="small"
                color="body1"
                onClick={() => { handleViewAutomation(automation) }}
            >
                {t("general-open_one")}
            </Button>
            <Dropdown
                size="medium"
                color="body1"
                variant="outlined"
                iconOnly
                options={getActionsDropdownOptions(automation)}
            />
        </Stack>
    )

    return {
        id: index,
        name: { id: automation.name, content: <NameTableCol name={automation.name} /> },
        status: { id: automation.status, content: renderStatusChip(automation.status) },
        list: {
            id: automation.list_id,
            content: <Link href={"#" + fetchRoute({ route: ERoutes.contacts }) + "?listId=" + automation?.list_id}>{partialList?.name || ""}</Link>
        },
        created_on: {
            id: automation.created_on,
            content: <Typography variant="body1L">{automation.created_on !== 0 ? getCalendarFormat({ unixDate: automation.created_on, showTime: true }) : ""}</Typography>
        },
        updated_on: {
            id: automation.updated_on,
            content: <Typography variant="body1L">{automation.updated_on !== 0 ? getCalendarFormat({ unixDate: automation.updated_on, showTime: true }) : ""}</Typography>
        },
        actions: actions
    }
}